<template>
    <b-container>
        <p v-if="article.externalInfo" class="p-2">{{article.externalInfo}}</p>
        <p v-if="article.externalInfoCustomer" class="p-2">{{article.externalInfoCustomer}}</p>
        <table class="table table-striped article-sheet">
            <tbody>
            <tr class="border-0" :key="item.key" v-for="(item) in articleDetailsFieldsFiltered">
                <td class="border-0">
                    {{item.label}}
                </td>
                <td class="border-0">
                    <span v-if="item.format">
                        {{item.format(article, variant)}}
                    </span>
                    <span v-else>
                        {{article[item.key]}}
                    </span>
                </td>
            </tr>
            <tr class="border-0">
                <td class="border-0">
                    Preferential origin
                </td>
                <td class="border-0">
                    {{Number(article.preferredOrigin) === 0 ? 'no' : 'yes'}}
                </td>

            </tr>

            </tbody>
        </table>
        <div class="text-center">
            <div :key="index" v-for="(img,index) in article.careLabelImages"
                 class="d-inline-block">
                <img width="50px" :src="require(`@shared/_assets/img/care-labels/${img}`)"/>
            </div>
        </div>
    </b-container>
</template>
<script>

    export default {
        data() {
            return {
                articleDetailsFields: [
                    {key: 'quality', label: 'Material:'},
                    {key: 'quantityUnit', label: 'Quantity unit:'},
                    {key: 'priceUnit', label: 'Price per:'},
                    {
                        key: 'weight', label: 'Weight', format: function (article, variant) {
                            return (variant && article) ? variant.weight + " g/" + article.priceUnit + " " + article.quantityUnit : "";
                        }
                    },
                    {key: 'material', label: 'Mat. composition'},
                    {key: 'countryOfOrigin', label: 'Country of origin'},
                    {key: 'bulkpriceThreshold', label: 'Bulk price limit'},
                    {key: 'tarifCode', label: 'Customs tariff number'},
                    {key: 'deliveryDuration', label: 'Standard lead time (bulk)'},
                ]
            }
        },
        props: {
            article: {
                type: Object
            },
            variant: {
                type: Object
            }
        },
        computed: {
            articleDetailsFieldsFiltered: function () {
                return this.articleDetailsFields.filter(item => {
                    return item.format ? item.format(this.article, this.variant) : this.article[item.key]
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

</style>